export enum OrganisationTabs {
  HOME = 'home',
  UPDATES = 'updates',
  PROJECTS = 'projects',
  ABOUT_US = 'about-us',
}
